import React, { useEffect, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Chip, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/api';
import { formatSize } from './ToolBackupList';

// The records saved in one tool backup, one table per kind of record
const ToolBackupDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [backup, setBackup] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getToolBackupDetails(id)
      .then((response) => setBackup(response?.data?.data || null))
      .catch(() => setError('Backup records could not be loaded.'));
  }, [id]);

  if (error) return <Typography color="error">{error}</Typography>;
  if (!backup) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 1600, mx: 'auto', pb: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate('/backup?tab=tools')} sx={{ mb: 2, textTransform: 'none', color: '#512DA8' }}>Back to tool backups</Button>
      <Typography sx={{ color: '#1D1F2C', fontSize: { xs: 28, md: 32 }, fontWeight: 700 }}>{backup.toolName}</Typography>
      <Typography sx={{ color: '#667085', fontSize: 16, mb: 3 }}>
        Last backed up on {new Date(backup.updatedAt || backup.createdAt).toLocaleString()} · {backup.recordCount} records · {formatSize(backup.sizeBytes)}
      </Typography>

      {(backup.parts || []).map((part) => (
        <Box key={part.collection} sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
            <Typography sx={{ color: '#1D1F2C', fontSize: 18, fontWeight: 700 }}>{part.label}</Typography>
            <Chip label={part.rows.length} size="small" sx={{ color: '#512DA8', backgroundColor: '#F3EEFF', fontWeight: 700 }} />
          </Box>
          <Paper variant="outlined" sx={{ borderColor: '#E0E2E7', borderRadius: 2, overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}><Table stickyHeader size="small" sx={{ minWidth: 700 }}>
              <TableHead><TableRow>
                <TableCell sx={{ fontWeight: 700, backgroundColor: '#F9FAFB' }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 700, backgroundColor: '#F9FAFB' }}>Customer</TableCell>
                <TableCell sx={{ fontWeight: 700, backgroundColor: '#F9FAFB' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700, backgroundColor: '#F9FAFB' }}>Created</TableCell>
              </TableRow></TableHead>
              <TableBody>
                {part.rows.map((row) => (
                  <TableRow key={row._id} hover>
                    <TableCell sx={{ fontWeight: 700 }}>{row.reference}</TableCell>
                    <TableCell>{row.customer || '-'}</TableCell>
                    <TableCell>{row.status ? <Chip label={row.status} size="small" sx={{ fontWeight: 600 }} /> : '-'}</TableCell>
                    <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString() : '-'}</TableCell>
                  </TableRow>
                ))}
                {!part.rows.length && <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, color: '#667085' }}>Nothing of this kind when the backup was made.</TableCell></TableRow>}
              </TableBody>
            </Table></TableContainer>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default ToolBackupDetails;
